import netlifyIdentity from "netlify-identity-widget";
import {Note, Project} from "../models/fauna/dbSchema";

// Notes

export async function getProjectNotes(projectID: string): Promise<Note[]> {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/get-project-notes', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({projectID})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    return res(response.json());
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function getSharedNote(noteID: string): Promise<any> {
    return new Promise((res, rej) => {
        async function call() {
            return await fetch('/.netlify/functions/get-shared-note', {
                method: 'POST',
                body: JSON.stringify({noteID})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    return res(response.json());
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function createNote(projectID: string, note: any): Promise<any> {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/create-note', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({note, projectID})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    return res(response.json());
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}
export async function createWaitlistEntry(entry: any): Promise<void> {
    return new Promise((res, rej) => {
        async function call() {
            return await fetch('/.netlify/functions/create-waitlist-entry', {
                method: 'POST',
                body: JSON.stringify({entry})
            })
                .then((response) => {
                    if (!response.ok) {
                        rej(response);
                    }
                    return res();
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function deleteNote(id: string) {
    return new Promise<any>((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/delete-note', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({id})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    res({});
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function updateNote(id: string, noteUpdates: any) {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/update-note', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({id, noteUpdates})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    res({});
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}


// Projects

export async function getProject(projectID: string): Promise<Project> {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/get-project', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({projectID})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    return res(response.json());
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function getUserProjects(): Promise<Project[]> {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/get-user-projects', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    return res(response.json());
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function getSharedProjects(): Promise<Project[]> {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/get-shared-projects', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    return res(response.json());
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function createProject(project: any, file?: File): Promise<string> {
    const {url, id} = await new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            const {id, ...rest} = project;
            return await fetch('/.netlify/functions/create-project', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({project: rest})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    return res(response.json());
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });

    if(url){
        await fetch(url, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': 'application/octet-stream',
            }
        }).then(() => updateProject(id, {status: 'uploaded'}));
    }
    return id;
}

export async function linkGoogleAccount(code: any): Promise<string> {
    return await new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/link-google-account', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({code})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    return res(response.json());
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });

}

export async function deleteProject(id: string, demo: boolean) {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/delete-project', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({id, demo})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    res({});
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function updateProject(id: string, projectUpdates: any) {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/update-project', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({id, projectUpdates})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    res({});
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

export async function _shareProject(email: string, projectID: string) {
    return new Promise((res, rej) => {
        async function call() {
            const user = await getUser();
            return await fetch('/.netlify/functions/share-project', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${user?.token?.access_token}`,
                },
                body: JSON.stringify({email, projectID})
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            logOutUser();
                        }
                        rej(response);
                    }
                    res({});
                }).catch(function (err) {
                    rej(err);
                });
        }

        call();
    });
}

// Identity

async function getUser() {
    const user = netlifyIdentity.currentUser();
    if (!user?.token?.access_token) {
        netlifyIdentity.open('login');
        return await new Promise<any>((resolve) => {
                netlifyIdentity.on('login', (user) => resolve(user));
            }
        )
    }
    return user;
}

export function getCurrentUser(){
    const user = netlifyIdentity.currentUser();
    if (!user?.token?.access_token) {
        return null;
    }
    return user;
}

function logOutUser() {
    netlifyIdentity.logout();
    netlifyIdentity.open("login");
}
